const siteId = process.env.REACT_APP_BUILD_SITE;

export const site = {
  id: siteId,
  isArgentina: /ZPAR/.test(siteId),
  isMexico: /24MX|VAMX/.test(siteId),
  isBrasil: /IWBR|WIBR|CMBR/.test(siteId),
  isPeru: /DVPE|UBPE/.test(siteId),
  isUrbania: /UBPE/.test(siteId),
  isEcuador: /PLEC/.test(siteId),
  isPanama: /CAPA/.test(siteId)
};

export const isBrasilSite = ['IWBR', 'WIBR', 'CMBR'].includes(siteId);

export const isSiteWithTelBanner = ['IWBR', 'WIBR'].includes(siteId);

export const isZonaDemandSite = ['ZPAR', '24MX', 'UBPE'].includes(siteId);

export const isPortalWithClonedPostings = ['24MX', 'UBPE'].includes(siteId);

export const isPortalWithUnifiedPanel = ['UBPE'].includes(siteId);

// deprecated - replaced by bumexFeature: ENABLED_CONTACT_DATA_MODAL
export const isPortalWithContactValidation = ['24MX'].includes(siteId);

// deprecated - replaced by bumexFeature: ENABLED_CHECK_UNREAD_LEADS
export const isPortalWithUnreadLeadsMsg = ['VAMX', '24MX'].includes(siteId);

// deprecated - replaced by bumexFeature: NEW_REPUTATION_SECTION
export const isPortalWithNewReputation = ['24MX'].includes(siteId);

export const isPortalWithConvertToFull = [].includes(siteId);
export const isOnboardingFullSite = [].includes(siteId);
